import { useState } from "react";
import { Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import TimelineList from "ui-components/Timeline/TimelineList";
import TimelineItem from "ui-components/Timeline/TimelineItem";

import { getPutawayLog } from "services/data.inbound.service";
import Drawer from "ui-components/Drawer"; 

const columns = [
  { label: "SKU Code", id: "skuCode" },
  { label: "Quantity", id: "quantity" },
  { label: "Pallet Nbr", id: "palletNbr" },
  { label: "Carton ID", id: "cartonID" },
  { label: "To Zone", id: "toZone" },
  { label: "To Location", id: "toLocation" },
  { label: "MLN", id: "mln" },
  { label: "Expiry Date", id: "expiryDate" },
  { label: "OLN", id: "oln" },
  { label: "PackType", id: "packType" },
];

function PutawayLog({ open, setOpen, logRequest, setLogRequest, setAlert }) {
  //const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  const [logs, setLogs] = useState(null);

  useQuery({
    queryKey: ["putaway-log", { logRequest }],
    queryFn: () => getPutawayLog(logRequest),
    enabled: logRequest !== null,
    onSuccess: (data) => {
      const item = data.data.data;

      const renderTimelineItems = item.logs.map(({ id, ...log }) => (
        <TimelineItem key={id} {...log} />
      ));
      setLogs(
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>Putaway Number : </b>
                {item.putawayNumber}
              </Grid>
              <Grid item xs={6}>
                <b>Recv Code : </b>
                {item.recvCode}
              </Grid>
              <Grid item xs={6}>
                <b>Customer Code : </b>
                {item.customerCode}
              </Grid>
              <Grid item xs={6}>
                <b>Vendor Code : </b>
                {item.vendorCode}
              </Grid>
              <Grid item xs={6}>
                <b>Warehouse Code : </b>
                {item.warehouseCode}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable columns={columns} rows={item.details} />
          </div>
          <TimelineList title="Logs">{renderTimelineItems}</TimelineList>
        </>
      );
    },
    //onError,
  });

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogs(null);
    setLogRequest(null);
  };

  return (
    <Drawer width="800px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      {logs}
    </Drawer>
  );
}

export default PutawayLog;
